import GridArchiveItemAlt from '../grid-archive/GridArchiveItemAlt'

export default function Itinerary({ events }) {
  if (!events || !events.length) {
    return null
  }

  // TODO: Do this sorting/groupuing in the API instead?

  // Sort events by event?.event_date?.start_date_ymd
  events.sort((a, b) => {
    const dateA = a?.event_date?.start_date_ymd
    const dateB = b?.event_date?.start_date_ymd

    return dateA - dateB
  })

  // Group items based on event?.event_date?.start_date_ymd
  const groupedEvents = events.reduce((acc, event) => {
    const date = event?.event_date?.start_date_long

    if (!acc[date]) {
      acc[date] = []
    }

    acc[date].push(event)

    return acc
  }, {})

  return (
    <div className="component component--itinerary">
      <div className="container">
        <div className="flex flex-col gap-m">
          {Object.entries(groupedEvents).map(([date, events], index) => {
            return (
              <div
                key={index}
                className="flex flex-col gap-s rounded-md border bg-theme p-l text-fg theme--base-0 m:p-m s:p-s">
                <div className="flex items-center gap-s rounded-md bg-theme-alt p-xs">
                  <svg className="h-[24px] w-[24px] xs:hidden" aria-hidden="true">
                    <use href={`${process.env.NEXT_PUBLIC_SPRITE_PATH}#icon-calendar`}></use>
                  </svg>
                  <span className="h4 s:h5 xs:h6">{date}</span>
                </div>

                <div className="flex flex-col gap-s xs:gap-m">
                  {events.map((event, eventIndex) => (
                    <GridArchiveItemAlt key={eventIndex} hit={event} />
                  ))}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
